import { NavObjectType, PopupPageId } from "../navigationTypes";
import { ListName } from "./List";

export const searchBarPlaceholder: Record<ListName, string> = {
    "FileList": "file",
    "LawyerList": "lawyer",
    "InsuranceList": "fire insurer",
    "RealEstateBrokerList": "real estate broker",
    "PurchaserRealEstateBrokerList": "real estate broker",
    "ConveyancerList": "conveyancer",
    "MortgageBrokerList": "mortgage broker",
    "MortgageLenderList": "mortgage lender",
    "AllMortgageLenderList" : "lender",
    "MortgageLenderSelectFieldList": "mortgage lender",
    "DischargeLenderList": "Discharge Center",
    "NotaryList": "notary",
    "AllLawyerList": "lawyer",
    "OtherPartyList": "other party",
    "SelectFileList": "file",
    "MortgageBranchList" : "Branch Name",
    "SuggestedList": "",
    "DRFileList": "file",
    "TaskList": "task description"
}

export const thirdPartyNavigateObjs: Record<ListName, NavObjectType> = {
    "FileList": null,
    'LawyerList': {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.Solicitor,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    "NotaryList": {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.Solicitor,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    "AllLawyerList": {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.Solicitor,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    'InsuranceList': {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.InsuranceAgent,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    'RealEstateBrokerList': {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.RealEstateAgent,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    'PurchaserRealEstateBrokerList': {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.PurchaserRealEstateAgent,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    'ConveyancerList': {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.Conveyancer,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    'MortgageBrokerList': {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.MortgageBroker,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    "MortgageLenderList": null,
    "AllMortgageLenderList" : null,
    "MortgageLenderSelectFieldList": null,
    "MortgageBranchList" : null,
    "SuggestedList": null,
    "DischargeLenderList": null,
    "OtherPartyList": {
        component: "main",
        url: "lfmaster.asp",
        controller: {
            tabName: PopupPageId.OtherParty,
        },
        params: {
            formasp: "purfileedit",
            tb: "TPAppXML",
        }
    },
    "SelectFileList": null,
    "DRFileList": null,
    "TaskList": null
}